import React, {Component} from 'react';
import {connect} from 'react-redux';
import Radio, {RadioGroup} from 'material-ui/Radio';
import {FormControl, FormControlLabel} from 'material-ui/Form';
import Select from 'react-select';
import Chart from 'chart.js';
import actions from 'actions';
import constants from 'constants';

const {getDataVisualisation, getWebinarData} = actions;
const {
  ROLES,
  PRIVATE_HOSPITALS_FILER,
  PHARMACEUTICAL_SPONSORS_FILER,
  CHART_COLORS,
} = constants;

let myChart = null;

class DataVisualisation extends Component {
  constructor() {
    super();

    this.state = {
      selectedGraph: 'pie_chart',
    };
  }

  componentDidMount() {
    const {handleGetWebinarData, params} = this.props;
    const webinar_id = params.id;
    handleGetWebinarData(webinar_id);
  }

  componentDidUpdate(prevProps) {
    const {dataVisualisation} = this.props;
    if (prevProps.dataVisualisation !== dataVisualisation) {
      this.redrawData(dataVisualisation);
    }
  }

  handleFilter = filter => {
    const {getDataVisualisation, webinar, params} = this.props;
    const webinar_id = webinar ? webinar.id : params.id;
    getDataVisualisation(webinar_id, filter);
  }

  getChartData = (type, data, backgroundColors, labels) => {
    const {filter} = this.props;
    const selectedFilter = PRIVATE_HOSPITALS_FILER.filter(filters => filters.value === filter)[0];
    const chartData = selectedFilter.value === 'accreditation' ? {labels: labels.map(label => label === "true" ? 'Irish' : 'International')} : {labels};
    switch(type) {
      case 'pie_chart':
        return {
          ...chartData,
          datasets: [{
            data,
            label: labels,
            backgroundColor: backgroundColors,
            hoverOffset: 4
          }],
        };
      case 'bar_graph':
        return {
          ...chartData,
          datasets: [{
            data,
            label: selectedFilter.label,
            backgroundColor: backgroundColors,
            hoverOffset: 4,
          }],
        };
      case 'dot_charts':
        return {
          ...chartData,
          datasets: [{
            data,
            label: selectedFilter.label,
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            pointBackgroundColor: backgroundColors,
            hoverOffset: 4,
          }],
        };
      default:
        return chartData;
    }
  }

  redrawData = newData => {
    const {selectedGraph} = this.state;
    const {filter} = this.props;
    const labelsKeys = Object.keys(newData);
    const labels = filter === PRIVATE_HOSPITALS_FILER[5].value ? labelsKeys.map(label => ROLES[label]) : labelsKeys;
    const data = labelsKeys.map(label => newData[label]);
    const ctx = document.getElementById('myChart');
    let colorIndex = 0;
    const backgroundColors = data.map(() => {
      colorIndex += 1;
      if (CHART_COLORS[colorIndex]) {
        return CHART_COLORS[colorIndex]
      } else {
        colorIndex = 0;
        return CHART_COLORS[colorIndex];
      }
    });
    const chartData = this.getChartData(selectedGraph, data, backgroundColors, labels);
    ctx.style = "max-width: 600px; margin: 0 auto;";
    if (myChart)
      myChart.destroy();

    myChart = new Chart(ctx, {
      type: this.getGraphName(selectedGraph),
      data: chartData,
    });
  }

  onChangeCounty = value => {
    this.setState({
      selectedCounty: value,
    });
  };

  getGraphName = type => {
    switch(type) {
      case 'pie_chart':
        return 'doughnut';
      case 'bar_graph':
        return 'bar';
      case 'dot_charts':
        return 'line';
      default:
        return 'doughnut';
    }
  }

  onGraphChange = event => {
    const {dataVisualisation, filter} = this.props;
    const selectedGraph = event.target.value;
    this.setState({selectedGraph});
    const ctx = document.getElementById('myChart');
    const labelsKeys = Object.keys(dataVisualisation);
    const labels = filter === PRIVATE_HOSPITALS_FILER[5].value ? labelsKeys.map(label => ROLES[label]) : labelsKeys;
    const data = labelsKeys.map(label => dataVisualisation[label]);
    let colorIndex = 0;
    const backgroundColors = data.map(() => {
      colorIndex += 1;
      if (CHART_COLORS[colorIndex]) {
        return CHART_COLORS[colorIndex]
      } else {
        colorIndex = 0;
        return CHART_COLORS[colorIndex];
      }
    });
    const chartData = this.getChartData(selectedGraph, data, backgroundColors, labels);
    ctx.style = "max-width: 600px; margin: 0 auto;";
    myChart.destroy();
    myChart = new Chart(ctx, {
      type: this.getGraphName(selectedGraph),
      data: chartData,
    });
  };

  render() {
    const {selectedGraph} = this.state;
    const {user, filter, webinar} = this.props;
    return (
      <main className="site--width">
        <div className="container_cpd row">
          <h2 className="data_title">
            {webinar ? (webinar.webinar_title || '') : ''}
          </h2>
          <div className="data_visualisation_container">
            <p className="dv_head">Select the data you want to display in graph</p>
            <div className="col s8 dv_select">
              <p className="input_country">Display by:</p>
              <Select
                options={user.sponsor_type === 'private_hospital' ? PRIVATE_HOSPITALS_FILER : PHARMACEUTICAL_SPONSORS_FILER}
                value={filter}
                onChange={(e) => this.handleFilter(e.value)}
              />
            </div>
            <div className='col s12 graph_select'>
              <FormControl>
                <RadioGroup
                  onChange={this.onGraphChange}
                  value={selectedGraph}
                  row
                >
                  <FormControlLabel
                    value={'pie_chart'}
                    control={<Radio color="primary"/>}
                    label="Pie chart"
                  />
                  <FormControlLabel
                    value={'bar_graph'}
                    control={<Radio color="primary"/>}
                    label="Bar graph"
                  />
                  <FormControlLabel
                    value={'dot_charts'}
                    control={<Radio color="primary"/>}
                    label="Dot Charts"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <canvas id="myChart" width="400" height="400"></canvas>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = ({stats, users}) => ({
  filter: stats.filter,
  dataVisualisation: stats.dataVisualisation,
  user: users.user,
  webinar: stats.webinar,
});

const mapDispatchToProps = dispatch => ({
  getDataVisualisation: (webinar_id, filter) => dispatch(getDataVisualisation(webinar_id, filter)),
  handleGetWebinarData: webinar_id => dispatch(getWebinarData(webinar_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DataVisualisation);



// WEBPACK FOOTER //
// ./src/containers/StatsLocker/DataVisualisation.js